export default function ProfyObjectFuckery(obj){
    return Array.isArray(obj) ? obj : Object.values(obj);
}